import { getCroppedImg } from './crop';

function downloadURL(url, filename) {
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export const generateDownload = async (imageSrc, pixels) => {
  if (!imageSrc || !pixels) return;
  const canvas = await getCroppedImg(imageSrc, pixels);

  // Základní kontrola – jestli nemáš 0×0
  if (!canvas.width || !canvas.height) {
    console.error('Cropped canvas has zero size', {
      pixels,
      w: canvas.width,
      h: canvas.height,
    });
    alert('Ořez selhal – prázdná oblast.');
    return;
  }

  // Safari fallback: když by toBlob nebyl k dispozici
  if (!canvas.toBlob) {
    const dataUrl = canvas.toDataURL('image/jpeg', 1);
    downloadURL(dataUrl, 'image.jpg');
    return;
  }

  // toBlob -> Promise
  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error('toBlob returned null'))),
      'image/jpeg',
      1
    );
  }).catch((err) => {
    console.error('toBlob failed:', err);
    alert(
      'Export selhal. Zkontroluj, že používáš croppedAreaPixels a že oblast není mimo obrázek.'
    );
    return null;
  });

  if (!blob) return;

  const url = URL.createObjectURL(blob);
  downloadURL(url, 'image.jpg');
  URL.revokeObjectURL(url);
};
